/**
 * Nala Back In Stock (BIS) - Klaviyo Integration
 * Handles email and SMS back-in-stock notifications
 */
(function() {
  'use strict';

  var klaviyoSelected = '';

  window.NalaBIS = {
    apiKey: 'UxKe8p',
    debug: true,

    log: function() {
      if (this.debug) {
        console.log('[NalaBIS]', ...arguments);
      }
    },

    init: function() {
      this.log('Initializing NalaBIS');
      this.bindEvents();
    },

    bindEvents: function() {
      var self = this;

      // Close modal on overlay click
      var overlay = document.querySelector('.bis-overlay');
      if (overlay) {
        overlay.addEventListener('click', function() {
          self.closeModal();
        });
      }

      // Close modal on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          self.closeModal();
        }
      });
    },

    open: function(variantId) {
      this.log('open() called with variantId:', variantId);
      if (variantId) {
        klaviyoSelected = variantId;
        window.klaviyoSelected = variantId;
      }
      this.log('klaviyoSelected set to:', klaviyoSelected);
      this.showModal(variantId);
    },

    showModal: function(variantId) {
      this.log('showModal() called with variantId:', variantId);
      var modal = document.getElementById('nala-bis-modal');
      if (modal) {
        var finalVariantId = variantId || klaviyoSelected;
        this.log('Setting modal data-variant-id to:', finalVariantId);
        modal.setAttribute('data-variant-id', finalVariantId);
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      } else {
        this.log('ERROR: Modal not found!');
      }
    },

    closeModal: function() {
      var modal = document.getElementById('nala-bis-modal');
      if (modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        this.resetForms();
      }
    },

    resetForms: function() {
      var modal = document.getElementById('nala-bis-modal');
      if (!modal) return;

      var emailForm = document.getElementById('nala-bis-form');
      var smsForm = document.getElementById('nala-bis-sms-form');
      if (emailForm) emailForm.reset();
      if (smsForm) smsForm.reset();

      var success = modal.querySelector('.bis-success');
      var error = modal.querySelector('.bis-error');
      var emailView = modal.querySelector('.bis-email-view');
      var smsView = modal.querySelector('.bis-sms-view');

      if (success) success.style.display = 'none';
      if (error) error.style.display = 'none';
      if (emailView) emailView.style.display = 'block';
      if (smsView) smsView.style.display = 'none';

      // Reset button states
      var emailBtn = modal.querySelector('.bis-email-view .bis-submit');
      var smsBtn = modal.querySelector('.bis-sms-view .bis-submit');
      if (emailBtn) {
        emailBtn.disabled = false;
        emailBtn.textContent = 'NOTIFY ME!';
      }
      if (smsBtn) {
        smsBtn.disabled = false;
        smsBtn.textContent = 'SUBMIT';
      }
    },

    showSMSView: function() {
      var modal = document.getElementById('nala-bis-modal');
      var emailView = modal.querySelector('.bis-email-view');
      var smsView = modal.querySelector('.bis-sms-view');
      if (emailView) emailView.style.display = 'none';
      if (smsView) smsView.style.display = 'block';
    },

    showEmailView: function() {
      var modal = document.getElementById('nala-bis-modal');
      var emailView = modal.querySelector('.bis-email-view');
      var smsView = modal.querySelector('.bis-sms-view');
      if (emailView) emailView.style.display = 'block';
      if (smsView) smsView.style.display = 'none';
    },

    // Email subscription
    subscribe: function(email, variantId, marketingConsent) {
      var self = this;
      this.log('subscribe() called');
      this.log('  - email:', email);
      this.log('  - variantId:', variantId);
      this.log('  - marketingConsent:', marketingConsent);

      var modal = document.getElementById('nala-bis-modal');
      var emailView = modal.querySelector('.bis-email-view');
      var submitBtn = emailView.querySelector('.bis-submit');
      var success = modal.querySelector('.bis-success');
      var error = modal.querySelector('.bis-error');

      submitBtn.disabled = true;
      submitBtn.textContent = 'Subscribing...';
      error.style.display = 'none';

      var profileAttributes = { email: email };
      var catalogVariantId = '$shopify:::$default:::' + variantId;

      this.log('  - catalogVariantId:', catalogVariantId);

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: catalogVariantId
              }
            }
          }
        }
      };

      this.log('  - Full payload:', JSON.stringify(payload, null, 2));

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + self.apiKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-06-15'
        },
        body: JSON.stringify(payload)
      })
      .then(function(response) {
        self.log('  - Response status:', response.status);
        if (response.status === 202) {
          self.log('  - SUCCESS: Subscribed to back-in-stock');

          // If marketing consent checked, also subscribe to marketing list
          if (marketingConsent) {
            self.subscribeToMarketing(email);
          }

          emailView.style.display = 'none';
          success.style.display = 'block';
        } else {
          return response.json().then(function(data) {
            self.log('  - Error data:', JSON.stringify(data, null, 2));
            throw new Error(data.errors?.[0]?.detail || 'Something went wrong');
          });
        }
      })
      .catch(function(err) {
        self.log('  - CATCH error:', err.message);
        error.textContent = err.message;
        error.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = 'NOTIFY ME!';
      });
    },

    // Subscribe to marketing list
    subscribeToMarketing: function(email) {
      var self = this;
      this.log('  - Marketing consent checked, subscribing to marketing list...');

      // Klaviyo Client Subscription API - email triggers email subscription
      var marketingPayload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            },
            custom_source: 'Back in Stock'
          }
        }
      };

      this.log('  - Marketing payload:', JSON.stringify(marketingPayload, null, 2));

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + self.apiKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(marketingPayload)
      })
      .then(function(res) {
        self.log('  - Marketing subscription response:', res.status);
      })
      .catch(function(err) {
        self.log('  - Marketing subscription error:', err.message);
      });
    },

    // SMS subscription
    subscribeSMS: function(phone, variantId, countryCode) {
      var self = this;
      this.log('subscribeSMS() called');
      this.log('  - phone:', phone);
      this.log('  - variantId:', variantId);
      this.log('  - countryCode:', countryCode);

      var modal = document.getElementById('nala-bis-modal');
      var smsView = modal.querySelector('.bis-sms-view');
      var submitBtn = smsView.querySelector('.bis-submit');
      var success = modal.querySelector('.bis-success');
      var error = modal.querySelector('.bis-error');

      submitBtn.disabled = true;
      submitBtn.textContent = 'Subscribing...';
      error.style.display = 'none';

      // Format phone number to E.164 format based on country
      var formattedPhone = this.formatPhoneNumber(phone, countryCode);
      this.log('  - formattedPhone:', formattedPhone);

      if (!formattedPhone) {
        error.textContent = 'Please enter a valid phone number';
        error.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = 'SUBMIT';
        return;
      }

      // Step 1: First obtain SMS consent (REQUIRED by Klaviyo)
      this.obtainSMSConsent(formattedPhone)
        .then(function() {
          // Step 2: Create back-in-stock subscription
          return self.createSMSBackInStock(formattedPhone, variantId);
        })
        .then(function() {
          self.log('  - SUCCESS: Subscribed to SMS back-in-stock');
          smsView.style.display = 'none';
          success.style.display = 'block';
        })
        .catch(function(err) {
          self.log('  - CATCH error:', err.message);
          error.textContent = err.message;
          error.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'SUBMIT';
        });
    },

    // Obtain SMS consent (required before BIS subscription)
    obtainSMSConsent: function(formattedPhone) {
      var self = this;

      // Klaviyo Client Subscription API - phone_number triggers SMS subscription
      var consentPayload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  phone_number: formattedPhone
                }
              }
            },
            custom_source: 'Back in Stock'
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'TziSeS'
              }
            }
          }
        }
      };

      this.log('  - SMS Consent payload:', JSON.stringify(consentPayload, null, 2));

      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + self.apiKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(consentPayload)
      })
      .then(function(response) {
        self.log('  - SMS Consent response status:', response.status);
        // 202 = success, 409 = already subscribed, 200 = ok (all are acceptable)
        if (response.status === 202 || response.status === 409 || response.status === 200) {
          self.log('  - SMS consent obtained successfully');
          return Promise.resolve();
        } else {
          return response.json().then(function(data) {
            self.log('  - SMS Consent error data:', JSON.stringify(data, null, 2));
            throw new Error(data.errors?.[0]?.detail || 'Failed to obtain SMS consent');
          });
        }
      });
    },

    // Create SMS back-in-stock subscription
    createSMSBackInStock: function(formattedPhone, variantId) {
      var self = this;

      var bisPayload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  phone_number: formattedPhone
                }
              }
            },
            channels: ['SMS']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      };

      this.log('  - BIS payload:', JSON.stringify(bisPayload, null, 2));

      return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + self.apiKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-06-15'
        },
        body: JSON.stringify(bisPayload)
      })
      .then(function(response) {
        self.log('  - BIS response status:', response.status);
        if (response.status === 202) {
          return Promise.resolve();
        } else {
          return response.json().then(function(data) {
            self.log('  - BIS error data:', JSON.stringify(data, null, 2));
            throw new Error(data.errors?.[0]?.detail || 'Something went wrong');
          });
        }
      });
    },

    // Format phone number to E.164 format
    formatPhoneNumber: function(phone, countryCode) {
      // Remove all non-digit characters
      var digits = phone.replace(/\D/g, '');
      this.log('formatPhoneNumber - digits:', digits, 'countryCode:', countryCode);

      if (!digits || digits.length < 6) {
        return null;
      }

      switch (countryCode) {
        case '61': // Australia
          // Remove leading 0 if present
          if (digits.startsWith('0')) {
            digits = digits.substring(1);
          }
          // AU mobile: 9 digits after removing 0 (4XX XXX XXX)
          if (digits.length >= 9 && digits.length <= 10) {
            return '+61' + digits;
          }
          // Already has country code
          if (digits.startsWith('61') && digits.length >= 11) {
            return '+' + digits;
          }
          return '+61' + digits;

        case '64': // New Zealand
          // Remove leading 0 if present
          if (digits.startsWith('0')) {
            digits = digits.substring(1);
          }
          // NZ mobile: 8-9 digits after removing 0
          if (digits.length >= 8 && digits.length <= 10) {
            return '+64' + digits;
          }
          // Already has country code
          if (digits.startsWith('64') && digits.length >= 10) {
            return '+' + digits;
          }
          return '+64' + digits;

        case '1': // USA/Canada
          // US numbers are 10 digits (area code + number)
          if (digits.length === 10) {
            return '+1' + digits;
          }
          // Already has country code
          if (digits.startsWith('1') && digits.length === 11) {
            return '+' + digits;
          }
          return '+1' + digits;

        default:
          // Default: add country code if not present
          if (digits.startsWith(countryCode)) {
            return '+' + digits;
          }
          return '+' + countryCode + digits;
      }
    },

    isAvailable: function() {
      return true;
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      NalaBIS.init();
    });
  } else {
    NalaBIS.init();
  }
})();
